import PropTypes from 'prop-types'
import { Box, Typography, Button } from '@mui/material'

import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg'

import styles from './styles'

const EmptyState = ({ title, text, buttonText, buttonAction }) => {
  return (
    <Box sx={styles.emptyState}>
      {title ? (
        <Typography
          variant="h2"
          align="center"
          color="neutral.black"
          sx={styles.emptyStateTitle}
        >
          {title}
        </Typography>
      ) : null}
      {text ? (
        <Typography variant="body1" align="center">
          {text}
        </Typography>
      ) : null}
      {buttonText && buttonAction ? (
        <Button
          onClick={buttonAction}
          size="small"
          variant="outlined"
          startIcon={<ArrowLeft />}
          sx={styles.emptyStateButton}
        >
          {buttonText}
        </Button>
      ) : null}
    </Box>
  )
}

EmptyState.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  buttonAction: PropTypes.func,
}

export default EmptyState
